import SessionTelemetry from '../store/schema/SessionTelemetry';
import { SmartComposeInteraction } from '@qas/smartcompose-tslibrary/dist/src/smartComposeInteraction';
const assign = require('object-assign');

export default function initializeTelemetryForSuggestion(
    session: SessionTelemetry,
    suggestionContext: string
): SmartComposeInteraction {
    const now = new Date();
    return assign(new SmartComposeInteraction(), {
        sessionId: session.sessionId,
        suggestionTraceId: undefined,
        suggestionRequestTime: now,
        context: suggestionContext,
        numberOfMatchingCharactersTyped: 0,
    });
}
